'use client';

export default function PrivacyPolicyPage() {
  return <div>Privacy policy page</div>;
}
